module.exports = __webpack_public_path__ + "static/media/_ionicons_svg_md-menu.4e10f85b.svg";